<template>
    <ListBase
        class="document-list-base"
        :items="items"
        :loading="isLoading"
        :max="max"
        :filters="filters"
        :sorts="sorts"
        :options="options"
    >
        <template slot="list-start">
            <slot name="list-start"></slot>
        </template>
        <template slot="list-empty">

        </template>
        <template slot="list-item" slot-scope="scope">
            <slot name="list-item" v-bind="scope"></slot>
        </template>
    </ListBase>
</template>

<script>
import { documentServices } from '@/modules/documents/services/DocumentServices'
import ListBase from '@/components/v3/lists/ListBase.vue'

export default {
    components: {
        ListBase
    },
    props: {
        max: {
            type: Number,
            default: -1
        },
        filters: {
            type: Array,
            default: () => []
        },
        sorts: {
            type: Array,
            default: () => [
                (a, b) => {
                return b.documentId - a.documentId
                }
            ]
        },
        options: {
            type: Object,
            default () { return {} }
        }
    },
    data () {
        return {
            items: [],
            isLoading: false
        }
    },
    mounted () {
        this.getItems()
    },
    computed: {
    },
    methods: {
        getItems () {
            console.log('document list base get items')
            this.items = []
            this.isLoading = true
            documentServices.getAllOrPublicUserDocumentList().then(response => {
                console.log('response', response)
                this.items = response.items
                this.$emit('data', this.items)
            }).catch(error => {
                this.$showNotification(
                    error.errors,
                    'error'
                )
            }).finally(() => {
                this.isLoading = false
            })
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.document-list-base
    // display flex
    // flex-flow row wrap
    // gap 24px
    display grid !important
    grid-grid-auto-columns minmax(320px, auto)
    grid-template-columns repeat(auto-fill, minmax(260px, 1fr))
    grid-gap 24px

    @media screen and (max-width: $mobile-step1-max-width)
        grid-grid-auto-columns minmax(220px, auto)
        grid-template-columns repeat(auto-fill, minmax(220px, 1fr))
        grid-gap 12px

</style>



// WEBPACK FOOTER //
// src/modules/documents/components/DocumentListBase.vue